import React, { createContext, useContext, useState, useEffect } from 'react';

type Country = 'Botswana' | 'South Africa' | 'Zimbabwe' | 'Namibia' | 'Zambia';

interface CountryContextType {
  selectedCountry: Country;
  setSelectedCountry: (country: Country) => void;
  availableCountries: Country[];
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const CountryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedCountry, setSelectedCountryState] = useState<Country>('Botswana');

  useEffect(() => {
    try {
      const saved = localStorage.getItem('selected_country');
      if (saved) {
        setSelectedCountryState(saved as Country);
      }
    } catch (e) {
      console.warn('Failed to load selected country from localStorage', e);
    }
  }, []);

  const availableCountries: Country[] = ['Botswana', 'South Africa', 'Zimbabwe', 'Namibia', 'Zambia'];

  const setSelectedCountry = (country: Country) => {
    setSelectedCountryState(country);
    try {
      localStorage.setItem('selected_country', country);
    } catch (e) {
      console.warn('Failed to save country to localStorage', e);
    }
  };

  return (
    <CountryContext.Provider value={{ selectedCountry, setSelectedCountry, availableCountries }}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (context === undefined) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};
